import { render, staticRenderFns } from "./WeekdaysTabs.vue?vue&type=template&id=692e4c9c"
import script from "./WeekdaysTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekdaysTabs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports